export enum MensagensModalConfirmacaoEnum {
    ALTERAR_CONTROLE_AERACAO = 'Deseja realmente alterar o \n controle da aeração?',
    ALTERAR_PROGRAMA_AERACAO = 'Deseja realmente alterar o \n programa da aeração?',
    ALTERAR_VARIAVEL_AERACAO = 'Deseja realmente alterar a \n variável de aquecimento?',
}
